import { normalizeMenuPath } from '~/composables/useClinicMenu';
import { isLocalShopPath } from '~/utils/shopHost';
import { isReservedShortLinkCode } from '~/utils/reservedShortLinkCodes';

export default defineNuxtRouteMiddleware(async (to) => {
    const shopHost = useShopHost();
    // У витрины свои адреса из одного-двух сегментов (`/moskva/`, `/korzina/`), их не трогаем.
    // На локали те же страницы лежат под `/katalog/` и не должны уходить в редирект блога.
    if (shopHost.isShopHost.value || (shopHost.mountOnMainSite.value && isLocalShopPath(to.path))) {
        return;
    }

    const apiBaseUrl = useApiBaseUrl();

    const path = to.path;

    if (path === '/roadbook' || path === '/roadbook/' || path.startsWith('/roadbook/')) {
        return;
    }

    // редиректы для документов
    const documents = [
        '/consent-personal-data/',
        '/consent-personal-data-vets/',
        '/licenzionnyj-dogovor/',
        '/oferta_accept/',
        '/polzovatelskoe-soglashenie-so-spec/',
        '/privacy-policy/',
        '/terms-of-usage/',
        '/uslovija-dlja-specialistov-i-klinik/',
        '/veterinary_user_agreement/'
    ]
    if(documents.includes(path)) {
        return navigateTo(`/documents${to.path}`, {redirectCode: 301});
    }

    // редиректы для авторизации
    if(path === '/registration/' || path === '/login-clinic/')  return navigateTo(`/`, {redirectCode: 301});

    // редиректы для ЛК
    const lkPaths = [
        '/home/',
        '/pet-profile/',
        '/my-appointments/',
        '/clinic-dashboard/',
        '/clinic-vets/',
        '/clinic-services/',
        '/clinic-profile/',
        '/vet-home/',
        '/calendar/'
    ]
    if(lkPaths.includes(path)) {
        return navigateTo(`/`, {redirectCode: 301});
    }

    if(path === '/4lapy/') return navigateTo(`/veterinars/online/`, {redirectCode: 301});
    if(path === '/vets/') return navigateTo(`/veterinars/`, {redirectCode: 301});

    // Редirect со старого URL выезда /{city}/vyesd/ → /veterinars/{city}/vyesd/
    const visitOldPathMatch = path.match(/^\/([a-z-]+)\/vyesd(\/.*)?$/);
    if (visitOldPathMatch) {
        const city = visitOldPathMatch[1];
        const rest = visitOldPathMatch[2] ?? '/';
        const suffix = rest.endsWith('/') ? rest : `${rest}/`;
        return navigateTo(`/veterinars/${city}/vyesd${suffix}`, { redirectCode: 301 });
    }

    if(path.includes('/polzovatelskoe-soglashenie-so-spec/info@vetsy.ru')) return navigateTo(`/documents/polzovatelskoe-soglashenie-so-spec/`, {redirectCode: 301});
    if(path === '/veterinarians/online/') return navigateTo(`/veterinars/online/`, {redirectCode: 301});
    if(path === '/clinics-sitemap.xml') return navigateTo(`/`, {redirectCode: 301});
    if(path === '/sitemap_index.xml') return navigateTo(`/`, {redirectCode: 301});
    if(path === '/vet-filter-sitemap.php') return navigateTo(`/`, {redirectCode: 301});
    if(path === '/vet-sitemap.xml') return navigateTo(`/`, {redirectCode: 301});
    if(path === '/productcat-sitemap.html') return navigateTo(`/`, {redirectCode: 301});
    if(path === '/vet/kozlov-artem-sergeevich/') return navigateTo(`/veterinars/40753-kozlov-artem-sergeevich/`, {redirectCode: 301});
    if(/^\/veterinars\/\d+\/$/.test(path)) throw createError({ statusCode: 404, statusMessage: 'Страница не найдена', fatal: true });
    if(path === '/clinics/moskva/tri-kota/') throw createError({ statusCode: 404, statusMessage: 'Клиника не найдена', fatal: true });
    if(path === '/clinics/vetera/') throw createError({ statusCode: 404, statusMessage: 'Клиника не найдена', fatal: true });
    if(path === '/clinics/jeliris/') throw createError({ statusCode: 404, statusMessage: 'Клиника не найдена', fatal: true });
    if(path.includes('/pdf/appointments/')) return navigateTo(`/`, {redirectCode: 301});
    if(path.includes('/pdf/appointments/')) return navigateTo(`/`, {redirectCode: 301});
    if(/^(\/[a-zA-Z0-9-_]+)*\/zaglushka_files(\/[a-zA-Z0-9-_]+)*\/maintenance-background\.svg$/.test(path)) return navigateTo(`/`, {redirectCode: 301});
    if (path === '/clinics/gjjj/') throw createError({ statusCode: 404, statusMessage: 'Клиника не найдена', fatal: true });
    if (path === '/clinics/nn/') return navigateTo(`/clinics/nizhniy-novgorod/`, { redirectCode: 301 });
    if (path === '/veterinars/tumanova-irina-sergeevna/') return navigateTo(`/veterinars/45578-tumanova-irina-sergeevna/`, { redirectCode: 301 });
    if (path === '/veterinars/sapelkin-ivan-vasilevich/') return navigateTo(`/veterinars/43564-sapelkin-ivan-vasilevich/`, { redirectCode: 301 });
    if (path === '/veterinars/madzaeva-tatjana-albertovna/') return navigateTo(`/veterinars/39980-madzaeva-tatjana-albertovna/`, { redirectCode: 301 });
    if (path === '/veterinars/jashina-polina-alekseevna/') return navigateTo(`/veterinars/53191-devjashina-viktorija-evgenevna/`, { redirectCode: 301 });
    if (path === '/veterinars/german-evgenija-vjacheslavovna/') return navigateTo(`/veterinars/37999-german-evgenija-vjacheslavovna/`, { redirectCode: 301 });
    if (path === '/blog/undefined/') return navigateTo(`/blog/`, { redirectCode: 301 });
    if (path === '/veterinars/41813-zolotuhina-kristina-vjacheslavovna/') return navigateTo(`/veterinars/41813-zolotuhina-kristina-vyacheslavovna/`, { redirectCode: 301 });
    if (path === '/veterinars/44055-knjazev-evgenij-sergeevich/') return navigateTo(`/veterinars/44055-knyazev-evgeniy-sergeevich/`, { redirectCode: 301 });
    if (path === '/veterinars/44184-pljusnina-galina-vladislavovna/') return navigateTo(`/veterinars/44184-plyusnina-galina-vladislavovna/`, { redirectCode: 301 });
    if (path === '/veterinars/49164-frolova-anastasija-ivanovna/') return navigateTo(`/veterinars/49164-frolova-anastasiya-ivanovna/`, { redirectCode: 301 });
    if (path === '/veterinars/53992-teleljuhina-tatjana-igorevna/') return navigateTo(`/veterinars/53992-telelyuhina-tatyana-igorevna/`, { redirectCode: 301 });
    if (path === '/clinics/krasnodar/kasper-2__trashed/') return navigateTo(`/clinics/krasnodar/kasper/`, { redirectCode: 301 });
    if (path === '/clinics/sankt-peterburg/medsvet__trashed/') return navigateTo(`/clinics/sankt-peterburg/vetklinika-medsvet/`, { redirectCode: 301 });
    if (path === '/veterinars/vardanjan-dajana-levonovna/') return navigateTo(`/veterinars/43428-vardanjan-dajana-levonovna/`, { redirectCode: 301 });
    if (path === '/veterinars/32679-belaja-elena-vladimirovna/') return navigateTo(`/veterinars/32679-belaya-elena-vladimirovna/`, { redirectCode: 301 });
    if (path === '/veterinars/32679-belaya-elena-vladimira/') return navigateTo(`/veterinars/32679-belaya-elena-vladimirovna/`, { redirectCode: 301 });
    if (path === '/veterinars/36342-petrova-ksenija-pavlovna/') return navigateTo(`/veterinars/36342-petrova-kseniya-pavlovna/`, { redirectCode: 301 });
    if (path === '/veterinars/smorodina-elena-mihajlovna/') return navigateTo(`/veterinars/41796-smorodina-elena-mihajlovna/`, { redirectCode: 301 });
    if (path === '/veterinars/49859-maljutina-oksana-evgenevna/') return navigateTo(`/veterinars/49859-malyutina-oksana-evgenevna/`, { redirectCode: 301 });
    if (path === '/clinics/veterinarnaja-klinika-kis-vet/') return navigateTo(`/clinics/moskva/veterinarnaja-klinika-kis-vet/`, { redirectCode: 301 });
    if (path === '/clinics/krasnodarskaya-gosudarstvennaya-stantsiya-po-borbe-s-boleznyami-zhivotnykh/') return navigateTo(`/clinics/krasnodar/krasnodarskaya-gosudarstvennaya-stantsiya-po-borbe-s-boleznyami-zhivotnykh/`, { redirectCode: 301 });
    if (path === '/blog/undefined/') return navigateTo(`/blog/`, { redirectCode: 301 });
    if (path === '/blog/%D1%81%D0%BE%D0%B1%D0%B0%D0%BA%D0%B8/') return navigateTo(`/blog/`, { redirectCode: 301 });
    if (path === '/blog/testovaya-novost/') return navigateTo(`/blog/`, { redirectCode: 301 });

    const cities = {
        rodionovo_nesvetaiskaya: 'rodionovo-nesvetaiskaya',
        nizhny_novgorod: 'nizhny-novgorod',
        podgornyaya_pokrovka: 'podgornyaya-pokrovka',
    }
    if(cities[path.split('/')[2]]) {
        const city = path.split('/')[2];
        const newPath = path.replace(city, cities[city]);
        return navigateTo(newPath, {redirectCode: 301});
    }


    // редиректы для списка ветеринаров, где в фильтре выбрано животное.
    const animalRegex = /^\/veterinars\/([a-zA-Z0-9-_]+)\/(koshka|sobaka)\/$/;
    const match = path.match(animalRegex);
    if (match) {
        const city = match[1]; // Извлекаем название города
        const newPath = `/veterinars/${city}/` + (match[2] === 'koshka' ? 'koshek' : 'sobak'); // Определяем новый путь
        return navigateTo(newPath, { redirectCode: 301 }); // Делаем редирект
    }


    const staticRoutes = [
        '/about/',
        '/app/',
        '/clinic-onboarding/',
        '/clinic-registration/',
        '/service/',
        '/sitemap',
        '/ui-kit/',
        '/vet-onboarding/',
        '/vet-registration/',
        '/blog',
        '/simptomy',
        '/book-appointment/',
        '/clinics/',
        '/documents/',
        '/profile/',
        '/profile-clinic/',
        '/profile-doctor/',
        '/fest4l/',
        '/uslugi/',
        '/veterinars/',
        '/vyzov-veterinara-na-dom/',
        '/feed.yml',
        '/google18460dd76040d05b.html',
        '/files/',
        '/veterinar-rating/',
        '/help/',
        '/share/',
        '/roadbook/',
    ]
    const normalizedPath = normalizeMenuPath(path);
    const exists = staticRoutes.some(route => normalizedPath.includes(route));

    if(!exists && normalizedPath !== '/' && normalizedPath.split('/').length <= 3) {

        // редиректы для коротких ссылок
        const clearLink = path.replace(/\//g, '');
        if(clearLink.length === 6 || clearLink.length === 5) {
            if (isReservedShortLinkCode(clearLink)) {
                throw createError({ statusCode: 404, statusMessage: 'Страница не найдена', fatal: true });
            }
            try {
                const responseShortLinks = await $fetch<any>(`public/link/resolve/`, {
                    baseURL: apiBaseUrl,
                    headers: { Accept: 'application/json' },
                    method: 'POST',
                    body: {
                        code: clearLink
                    }
                });
                if (responseShortLinks?.data) {
                    return navigateTo(responseShortLinks.data.url, { redirectCode: 302, external: true });
                }
            } catch (error) {
                throw createError({ statusCode: 404, statusMessage: 'Страница не найдена' });
            }
        }
        
        // редиректы для статей
        try {
            const responseBlog = await $fetch<{ data?: unknown }>(`public/posts${path}`, {
                baseURL: apiBaseUrl,
                headers: { Accept: 'application/json' },
            });
            if (responseBlog?.data) {
                return navigateTo(`/blog${path}`, { redirectCode: 301 });
            }
        } catch (error: unknown) {
            const fetchError = error as { statusCode?: number; response?: { status?: number } };
            if (fetchError.statusCode !== 404 && fetchError.response?.status !== 404) {
                throw error;
            }
        }

        throw createError({ statusCode: 404, statusMessage: 'Страница не найдена' });
    }
})
